import { lazy } from 'react';

export const ADPPage = lazy(() => import('./ADPPage'));
